import { render, staticRenderFns } from "./ReturnLabel.vue?vue&type=template&id=4acc440b&"
import script from "./ReturnLabel.vue?vue&type=script&lang=js&"
export * from "./ReturnLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports